
import React, { createContext, useContext, useState, useEffect,useRef } from 'react'
const ShopContext = createContext(null)  

const ShopContextProvider= ({db, children }) => {
  

  const [shop, setShop] = useState('Gailingen')
  
  useEffect(()=>{
    const getShop=async()=>
    {
      const shop=await db.shops.get('MyShop')
      if(shop)
        setShop(shop)
    }
    if(db)
      getShop()
  })

  
  return (
    <ShopContext.Provider value={ shop }>
    {
        children
    }
    </ShopContext.Provider>
  )
}

export default ShopContextProvider

export const useShop = () => 
{
  const result= useContext(ShopContext)
  return result
}

